import React, { useState } from "react";

import MainLayout from "../../components/MainLayout";
import Comics from "./container/Comics";
import Popup from "../../components/Popup";

import { getDomainWithLanguageURL } from "../../utils/languageFunctions";


const HomePage = () => {

    // State para el popup window
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [comicLink, setComicLink] = useState("");

    const togglePopup = (link) => {  // Poner un parametro en esta funcion? Para pasar el link del Comic ???

        setIsPopupOpen(!isPopupOpen);
        setComicLink(link);
    };
    

    return <MainLayout>
        {isPopupOpen && <Popup handleClose={togglePopup} comicLink={comicLink} />} 
        <Comics togglePopup={togglePopup} urlPart={getDomainWithLanguageURL()} />
    </MainLayout>
}; 

export default HomePage; 